import { render, staticRenderFns } from "./ks-recruit-list.vue?vue&type=template&id=780b5866"
var script = {}
import style0 from "./ks-recruit-list.vue?vue&type=style&index=0&id=780b5866&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports